import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  mergeApplicationConfig,
} from '@angular/core';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RecaptchaModule } from '@boels/shared-state';
import { AuthenticationModule } from './authentication/authentication.module';
import { ConsentModule } from './consent/consent.module';
import { NewrelicModule } from './newrelic-monitoring/newrelic.module';
import { PageViewTrackingModule } from './page-view-tracking/page-view-tracking.module';
import { SalesForceChatModule } from './salesforce-chat/salesforce-chat.module';
import { sharedConfig } from './app.config.shared';
import { InsightsModule } from './insights/insights.module';
import { AppConfig } from '@boels/models';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  BoelsBrowserHttpCacheInterceptor,
  BoelsBrowserHttpCacheService,
} from './interceptor/boels-browser-http-cache.interceptor';

const isNotIframe = window.self === window.top;

const appConfig: ApplicationConfig = {
  providers: [
    isNotIframe
      ? importProvidersFrom(
          InsightsModule,
          NewrelicModule,
          RecaptchaModule,
          AuthenticationModule,
          NewrelicModule,
          ConsentModule,
          BrowserAnimationsModule,
          GoogleTagManagerModule,
          PageViewTrackingModule,
          SalesForceChatModule,
        )
      : importProvidersFrom(RecaptchaModule, BrowserAnimationsModule),
    {
      provide: 'googleTagManagerId',
      useFactory: () => {
        const environment = inject<AppConfig>('ENVIRONMENT' as any);
        return environment.gtm.gtmId;
      },
    },
    {
      provide: 'googleTagManagerResourcePath',
      useFactory: () => {
        const environment = inject<AppConfig>('ENVIRONMENT' as any);
        return environment.gtm.gtm_resource_path;
      },
    },
    BoelsBrowserHttpCacheService,
    provideHttpClient(
      withFetch(),
      withInterceptors([BoelsBrowserHttpCacheInterceptor]),
      withInterceptorsFromDi(),
    ),
  ],
};

export const browserConfig: ApplicationConfig = mergeApplicationConfig(
  sharedConfig,
  appConfig,
);
